import { render, staticRenderFns } from "./changepassword.vue?vue&type=template&id=ff087d06&scoped=true&"
import script from "./changepassword.vue?vue&type=script&lang=ts&"
export * from "./changepassword.vue?vue&type=script&lang=ts&"
import style0 from "./changepassword.vue?vue&type=style&index=0&id=ff087d06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff087d06",
  null
  
)

export default component.exports